define('views/blocks/SubscribePostcodeView',['underscore',
        'jquery',
        'backbone',
        'CSS3Events',
        'app',
        'InputView',
        'template!blocks/notice/subscribe-postcode',
	],
    function (_,
              $,
              Backbone,
              CSS3Events,
              app,
              InputView,
              subscribePostcodeTemplate
    ) {


    var self, addressAutocompleteModel;
    var TRANSLATION_CONTEXT = 'AddressAutocomplete';

    return Backbone.View.extend({

        events: {
            'click .overlay': 'hide',
            'click .no-thanks': 'noThanks',
            'click .btn-clickandco': 'clickAndCo',
            'submit form':'submitEmail'
        },
        initialize:function(options){

            self = this;
            addressAutocompleteModel = options.addressAutocompleteModel;
            self.render(false);

        },

        render:function(ignoreRetemplating){
            var html = $(subscribePostcodeTemplate({
                title:app.t('Cette adresse ne semble pas être déservie',TRANSLATION_CONTEXT),
                subtitle:app.t('Laissez votre adresse mail pour être prévenu lorsqu’un shop ouvrira à proximité !',TRANSLATION_CONTEXT),
                input_placeholder:app.t('par ex. tdupont@exemple.fr',TRANSLATION_CONTEXT),
                no_thanks:app.t('Non merci',TRANSLATION_CONTEXT),
                subscribe:app.t('Prévenez-moi !',TRANSLATION_CONTEXT),
                go_store:app.t('Je vais en boutique',TRANSLATION_CONTEXT),
                email:app.getCustomer().getEmail() || '',
            }));
            self.setElement(html);
            $('.site').append(html);
            InputView.initializeInputsOfView(self);
            self.show();
            self.$(':text').focus();
        },

        noThanks:function(){
            if(self.$('.step-1').is(':visible')){
                self.nextStep(false);
            }else{
                self.hide(false);
            }
        },

        clickAndCo:function(){
            self.hide(true);
        },

        submitEmail:function(e){
            e.preventDefault();
            var email = self.$('[name=email]').val(),
                btnSubscribe = self.$('.btn-subscribe-postcode');
            function toggleLoading(loading){
                self.$('fieldset').attr('disabled',loading);
                btnSubscribe.addClass('loading',loading);
            }
            toggleLoading(true);
            addressAutocompleteModel.subscribePostcode(email).done(function(){
                self.nextStep(true);
                toggleLoading(false);
            }).fail(function(){
                app.alert();
                toggleLoading(false);
            });
        },

        nextStep:function(success){
            var m = success ?
                'C’est enregistré ! Nous vous dirons quand nous aurons des nouvelles.' :
                'Pas de problème, cherchez vous-même la boutique la plus proche !';
            self.$('.step-2 .subtitle').text(app.t(m,TRANSLATION_CONTEXT));
            self.$('.step-1').slideUp();
            self.$('.step-2').slideDown();
        },

        show: function () {
            setTimeout(function () {
                self.$el.addClass('active');
            }, 1)
        },

        hide: function (success) {
            self.$('.content').one(CSS3Events('transitionend'), function () {
                self.trigger('noticeClose',!!success);
                self.remove();
            });
            self.$el.removeClass('active');
        }

    });
});
